var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      attrs: {
        "append-to-body": true,
        "destroy-on-close": true,
        modal: false,
        size: _vm.isMobile ? "80%" : "40%",
        visible: _vm.communityDrawer,
        "custom-class": "Order-Detail-Drawer",
        direction: "rtl",
      },
      on: {
        "update:visible": function ($event) {
          _vm.communityDrawer = $event
        },
      },
    },
    [
      JSON.stringify(_vm.orderData) !== "{}"
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "Container",
            },
            [
              _c("div", { staticClass: "Top" }, [
                _c("div", { staticClass: "T-Left" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.orderData.resourceInfo.nameCn ||
                          _vm.orderData.resourceInfo.nameEn
                      )
                    ),
                  ]),
                  _vm.orderData.resourceInfo.nameCn
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.orderData.resourceInfo.nameEn)),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "T-Right" }, [
                  _c("i", {
                    staticClass: "el-icon-close",
                    on: {
                      click: function ($event) {
                        _vm.communityDrawer = false
                      },
                    },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "Header" }, [
                _c("div", { staticClass: "Resource-Info" }, [
                  _c(
                    "div",
                    { staticClass: "Images" },
                    [
                      _c(
                        "el-carousel",
                        {
                          attrs: {
                            interval: 5000,
                            height: "180px",
                            "indicator-position": "outside",
                          },
                        },
                        [
                          _c("el-carousel-item", [
                            _c("img", {
                              staticClass: "Carousel-Image",
                              attrs: {
                                src:
                                  _vm.orderData.resourceInfo.imageUrl ||
                                  "https://media.onyx-hospitality.com/-/media/project/amari/common/property/bangkok/hotel-photos/stay/club_one-bedroom_executive-suite/club_one-bedroom_executive-suite.jpg?rev=-1",
                                alt: "资源图片",
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("h2", { staticClass: "Resource-Name" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.orderData.resourceInfo.nameCn ||
                            _vm.orderData.resourceInfo.nameEn
                        )
                      ),
                    ]),
                    _vm.orderData.resourceInfo.nameCn
                      ? _c("span", { staticClass: "En-Name" }, [
                          _vm._v(_vm._s(_vm.orderData.resourceInfo.nameEn)),
                        ])
                      : _vm._e(),
                  ]),
                  _vm.orderData.resourceInfo.addressCn
                    ? _c("div", { staticClass: "location-info" }, [
                        _c("i", { staticClass: "el-icon-location" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.orderData.resourceInfo.cityNameCn ||
                                _vm.orderData.resourceInfo.cityName
                            ) +
                            " · " +
                            _vm._s(
                              _vm.orderData.resourceInfo.addressCn ||
                                _vm.orderData.resourceInfo.address
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("i", {
                  staticClass: "el-icon-close Close-Icon",
                  on: {
                    click: function ($event) {
                      _vm.communityDrawer = false
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "Main-Content scroll-area" }, [
                _c(
                  "div",
                  { staticClass: "Info-Card" },
                  [
                    _c("h3", { staticClass: "Card-Title" }, [
                      _vm._v("商品明细"),
                    ]),
                    _vm._l(
                      _vm.orderData.orderListResult.orderListDetailResultList,
                      function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "Product-Item" },
                          [
                            _c("div", { staticClass: "Product-Header" }, [
                              _c("span", { staticClass: "Product-Name" }, [
                                _vm._v(
                                  _vm._s(item.productNameCn || item.productName)
                                ),
                              ]),
                              _c("span", { staticClass: "Product-En" }, [
                                _vm._v(_vm._s(item.productNameEn)),
                              ]),
                            ]),
                            _c(
                              "el-row",
                              {
                                staticClass: "Detail-Row",
                                attrs: { gutter: 20 },
                              },
                              [
                                _c("el-col", [
                                  _c("div", { staticClass: "Detail-Item" }, [
                                    _c("label", [_vm._v("使用日期：")]),
                                    _vm.orderData.orderListResult.state === 0
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              item.startTime.replace(/\./g, "-")
                                            ) +
                                              " 至 " +
                                              _vm._s(
                                                _vm.addOneDay(item.endTime)
                                              )
                                          ),
                                        ])
                                      : item.startTime === item.endTime
                                      ? _c("span", [
                                          _vm._v(_vm._s(item.startTime)),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(item.startTime) +
                                              " 至 " +
                                              _vm._s(item.endTime)
                                          ),
                                        ]),
                                  ]),
                                  _c("div", { staticClass: "Detail-Item" }, [
                                    _c("label", [_vm._v("取消数量：")]),
                                    _c("span", [
                                      _vm._v(_vm._s(item.cancelNumber || 0)),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "Detail-Item" }, [
                                    _c("label", [_vm._v("实际数量：")]),
                                    _c("span", [_vm._v(_vm._s(item.number))]),
                                  ]),
                                  _c("div", { staticClass: "Detail-Item" }, [
                                    _c("label", [_vm._v("使用单位：")]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(item.priceCompany) +
                                          "/" +
                                          _vm._s(item.useTime)
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "Price-Section" }, [
                              _c("div", { staticClass: "Price-Line" }, [
                                _c("span", { staticClass: "Currency" }, [
                                  _vm._v(_vm._s(item.currency)),
                                ]),
                                _c("span", { staticClass: "Amount" }, [
                                  _vm._v(_vm._s(item.price)),
                                ]),
                                _c("span", { staticClass: "Unit" }, [
                                  _vm._v("× " + _vm._s(item.number)),
                                ]),
                                _c("span", { staticClass: "Unit" }, [
                                  _vm._v(
                                    " × " +
                                      _vm._s(
                                        _vm.days(
                                          item.startTime,
                                          item.endTime,
                                          _vm.orderData.orderListResult.state
                                            .state
                                        ) + 1
                                      ) +
                                      _vm._s(item.useTime)
                                  ),
                                ]),
                              ]),
                              item.currency !== "￥"
                                ? _c("div", { staticClass: "Rate-Line" }, [
                                    _c("span", [
                                      _vm._v(
                                        "汇率：1" +
                                          _vm._s(item.currency) +
                                          " ≈ " +
                                          _vm._s(item.rate) +
                                          "CNY"
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "Total-Line" }, [
                                _vm._v(
                                  " 小计：" +
                                    _vm._s(
                                      (
                                        item.price *
                                        (_vm.days(
                                          item.startTime,
                                          item.endTime,
                                          _vm.orderData.orderListResult.state
                                            .state
                                        ) +
                                          1) *
                                        item.rate *
                                        item.number
                                      ).toFixed(2)
                                    ) +
                                    "元 "
                                ),
                              ]),
                            ]),
                          ],
                          1
                        )
                      }
                    ),
                    _c("div", { staticClass: "Grand-Total" }, [
                      _c("span", { staticClass: "Label" }, [
                        _vm._v("订单总额："),
                      ]),
                      _c("span", { staticClass: "Amount" }, [
                        _vm._v(" " + _vm._s(_vm.totalAmount) + "元 "),
                      ]),
                    ]),
                  ],
                  2
                ),
                _vm.orderData.cgResultList &&
                _vm.orderData.cgResultList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "Info-Card" },
                      [
                        _c("h3", { staticClass: "Card-Title" }, [
                          _vm._v("资源取消政策"),
                        ]),
                        _vm._l(
                          _vm.orderData.cgResultList,
                          function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "cancel-remark-item" },
                              [
                                _c("div", { staticClass: "remark-header" }, [
                                  _c("div", { staticClass: "remark-title" }, [
                                    _c("span", { staticClass: "remark-name" }, [
                                      _vm._v(_vm._s(item.nameCn)),
                                    ]),
                                    item.nameEn
                                      ? _c(
                                          "span",
                                          { staticClass: "remark-en-name" },
                                          [_vm._v(_vm._s(item.nameEn))]
                                        )
                                      : _vm._e(),
                                    _c("span", { staticClass: "remark-time" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.dateFormatHm(item.createTime)
                                        )
                                      ),
                                    ]),
                                  ]),
                                  item.selected
                                    ? _c(
                                        "div",
                                        { staticClass: "remark-status" },
                                        [_vm._v("已确认")]
                                      )
                                    : _vm._e(),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "remark-content" },
                                  _vm._l(
                                    item.cancelRemark,
                                    function (remark, rIndex) {
                                      return _c("p", { key: rIndex }, [
                                        _vm._v(_vm._s(remark)),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.modifyOrderCancelResult
                  ? _c(
                      "div",
                      { staticClass: "Info-Card" },
                      [
                        _c("h3", { staticClass: "Card-Title" }, [
                          _vm._v("价格政策"),
                        ]),
                        _vm.orderData.orderListResult.truncationResult.statusResultList.some(
                          (v) => v.statusName === "FAILED_AND_REFUNDED"
                        )
                          ? _c("div", { staticClass: "refund-amount" }, [
                              _vm._v(
                                " 退款金额：" +
                                  _vm._s(
                                    _vm.modifyOrderCancelResult
                                      .refundableTotalAmount
                                  ) +
                                  "元 "
                              ),
                            ])
                          : _vm._e(),
                        _c(
                          "el-collapse",
                          { attrs: { accordion: "" } },
                          _vm._l(
                            _vm.modifyOrderCancelResult
                              .modifyOrderCancelDetailResultList,
                            function (item, index) {
                              return item.productName !== "城市税"
                                ? _c(
                                    "el-collapse-item",
                                    {
                                      key: index,
                                      attrs: { title: item.productName },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "policy-content" },
                                        [
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                item.cancellationPolicyDescription
                                              ),
                                            },
                                          }),
                                          _vm._l(
                                            item.stockInfo,
                                            function (group, gIndex) {
                                              return _c(
                                                "div",
                                                { key: gIndex },
                                                [
                                                  _c("h4", [
                                                    _vm._v(_vm._s(group.name)),
                                                  ]),
                                                  _vm._l(
                                                    group.value,
                                                    function (info, iIndex) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: iIndex,
                                                          staticClass:
                                                            "policy-item",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  info.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "value",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  info.value
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  )
                                : _vm._e()
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "Status-Horizontal" },
                  [
                    _c(
                      "el-steps",
                      {
                        attrs: {
                          active: _vm.activeStatusIndex,
                          "align-center": "",
                        },
                      },
                      _vm._l(
                        _vm.orderData.orderListResult.truncationResult
                          .statusResultList,
                        function (status, index) {
                          return _c("el-step", {
                            key: index,
                            attrs: {
                              status: status.highlight ? "process" : "wait",
                              title: status.statusText,
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "Info-Card" },
                  [
                    _c("h3", { staticClass: "Card-Title" }, [
                      _vm._v("操作记录"),
                    ]),
                    _c(
                      "el-timeline",
                      _vm._l(_vm.sortedLogs, function (log, index) {
                        return _c(
                          "el-timeline-item",
                          {
                            key: index,
                            attrs: {
                              color: _vm.themeColor,
                              timestamp: log.createTime,
                              placement: "top",
                            },
                          },
                          [
                            _c("div", {
                              staticClass: "Log-Card",
                              class: { "first-log": index === 0 },
                              domProps: { innerHTML: _vm._s(log.remark) },
                            }),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }